module.exports = __webpack_public_path__ + "337125e1d8391146a9238b877de5f82f.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/svg/circle-80.svg
// module id = 599
// module chunks = 0